import "../components/Styles/Property.css";

function Property() {
  return (
    <div className="property-page">

      {/* HERO SECTION */}
      <div
        className="property-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1974&auto=format&fit=crop')",
        }}
      >

        <div className="property-overlay"></div>

        <div className="property-content">

          <h1>
            BUY PROPERTY WITH 
            <span> CONFIDENCE</span>
            <br />
            TRUSTED PROPERTY
            <span> SERVICES</span>
          </h1>

          <h2>
            India’s #1 Property Legal Solutions
          </h2>

          <button>
            Get Started
          </button>

          <p>
            Property Verification | Documentation | Registration
          </p>

        </div>

      </div>

      {/* PROPERTY STATS SECTION */}

<div className="property-stats-section">

  <div className="property-stats-container">

    <h2 className="property-stats-title">
      We help you take the right property investment decision
    </h2>

    <div className="property-stats-grid">

      <div className="property-stat-card">
        <h3>35K+</h3>
        <p>Properties verified</p>
      </div>

      <div className="property-stat-card">
        <h3>15K+</h3>
        <p>Properties registered in 30+ cities</p>
      </div>

      <div className="property-stat-card">
        <h3>100K+</h3>
        <p>Pages of property documentation</p>
      </div>

      <div className="property-stat-card">
        <h3>150K</h3>
        <p>Happy users across the world</p>
      </div>

    </div>

  </div>

</div>

<div className="property-sale-intro text-center">
            <div className="container">
                <div className="sale-intro-block px-70 py-130">
                    <h2 className="m-0 font-24 font-weight-bold text-color-18 m-b-25">
                        Property Report
                    </h2>
                    <p className="m-0 font-18 lh-32 text-color-18">
                        The <b>Property Report</b> is the most important document before you buy a property. An expert property lawyer examines all the legal aspects of your property. They examine the Government records, available property paper chain to determine and confirm a property's legal ownership and determine any claims on the property. It reveals any mortgages, liens, judgements, or unpaid taxes that will have to be cleared before the property can be sold or purchased; and details of any existing easements, restrictions or leasing affecting the property.
                    </p>
                </div>
            </div>
        </div>

        {/* PROPERTY PRODUCTS SECTION */}

<div className="property-products">

  <div className="container product-list-div">

    <h1 className="property-heading">
      <span>
        Right Property Legal Products for
      </span>

      <span className="highlight">
        All your Sale and Purchase
      </span>
    </h1>

    {/* CARD 1 */}

    <div className="property-product-item popular">

      <div className="most-popular-badge">
        Most Popular
      </div>

      <div className="product-left">
        <h3>Agreement to Sale Drafting</h3>
      </div>

      <div className="product-middle">
        <ul>
          <li>Best in Class Agreement Drafting</li>
          <li>24 Hrs Drafting delivery</li>
        </ul>
      </div>

      <div className="product-price">
        ₹3999
      </div>

      <div className="product-btn">
        <button>Explore</button>
      </div>

    </div>

    {/* CARD 2 */}

    <div className="property-product-item">

      <div className="product-left">
        <h3>
          Property Registration
        </h3>
      </div>

      <div className="product-middle">
        <ul>
          <li>Get your property registered easily</li>
          <li>Dedicated Case Manager Support</li>
          <li>Doorstep delivery within 2 days</li>
        </ul>
      </div>

      <div className="product-price">
        ₹16999
      </div>

      <div className="product-btn">
        <button>Explore</button>
      </div>

    </div>

    {/* CARD 3 */}

    <div className="property-product-item">

      <div className="product-left">
        <h3>Sale Deed Drafting</h3>
      </div>

      <div className="product-middle">
        <ul>
          <li>Experienced Property Lawyers</li>
          <li>Consultation Call Included</li>
          <li>Final Draft in 48 Hours</li>
        </ul>
      </div>

      <div className="product-price">
        ₹4999
      </div>

      <div className="product-btn">
        <button>Explore</button>
      </div>

    </div>

    {/* CARD 4 */}

    <div className="property-product-item">

      <div className="product-left">
        <h3>Property Paper Review</h3>
      </div>

      <div className="product-middle">
        <ul>
          <li>30 Minutes Lawyer Consultation</li>
          <li>Legal Status & Red Flag Review</li>
          <li>Answers to all your doubts</li>
        </ul>
      </div>

      <div className="product-price">
        ₹4449
      </div>

      <div className="product-btn">
        <button>Explore</button>
      </div>

    </div>

    {/* CARD 5 */}

    <div className="property-product-item">

      <div className="product-left">
        <h3>Property Report</h3>
      </div>

      <div className="product-middle">
        <ul>
          <li>Detailed Analysis by Senior Lawyer</li>
          <li>Trusted Report & Peace of Mind</li>
          <li>Fast Delivery Across India</li>
        </ul>
      </div>

      <div className="product-price">
        ₹5999
      </div>

      <div className="product-btn">
        <button>Explore</button>
      </div>

    </div>

  </div>

</div>

{/* HOW IT WORKS SECTION */}

<div className="how-it-works-section">

  <div className="container">

    <h2 className="how-title">
      How it works?
    </h2>

    <div className="how-cards">

      {/* CARD 1 */}

      <div className="how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/1828/1828919.png"
          alt=""
        />

        <h3>1. Fill your details</h3>

        <p>
          Take out few seconds to fill your details.
          If you are our existing user, enter your
          mobile number and system will auto fill details.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/2991/2991112.png"
          alt=""
        />

        <h3>2. Upload your (pdf) document</h3>

        <p>
          Choose talk time and upload your pdf document.
          System will automatically calculate the number
          of pages.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/2784/2784459.png"
          alt=""
        />

        <h3>3. Schedule your call</h3>

        <p>
          Schedule your call with the expert on time
          and date that suits your convenience.
        </p>

      </div>

    </div>

  </div>

</div>

{/* WHY LegalAxis SECTION */}

<div className="lk-why-section">

  <div className="container">

    <h2 className="lk-why-title">
      Why LegalAxis?
    </h2>

    <div className="lk-why-wrapper">

      {/* CARD 1 */}
      <div className="lk-why-card">

        <div className="lk-why-icon">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt=""
          />
        </div>

        <h3>
          Property documentation from Anywhere
        </h3>

        <p>
          Get property documents reviewed, title checked,
          document verification, sale deed drafting,
          registrations, stamp paper and much more
          with a single click.
        </p>

      </div>

      {/* CARD 2 */}
      <div className="lk-why-card">

        <div className="lk-why-icon">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1995/1995574.png"
            alt=""
          />
        </div>

        <h3>
          Senior Legal Professionals with 24X7 Support
        </h3>

        <p>
          Only the best property lawyers will consult
          you 24X7. Faster delivery and premium legal
          support for all your property needs.
        </p>

      </div>

      {/* CARD 3 */}
      <div className="lk-why-card">

        <div className="lk-why-icon">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1827/1827392.png"
            alt=""
          />
        </div>

        <h3>
          Realtime Alerts & Updates
        </h3>

        <p>
          Receive important alerts and updates through
          WhatsApp and SMS. We ensure complete
          transparency and timely service delivery.
        </p>

      </div>

    </div>

  </div>

</div>

{/* LEGAL SOLUTION SECTION */}

<div className="virtual-section">

  <div className="container">

    <h2 className="virtual-title">
      All property legal solutions under one roof
    </h2>

    <p className="virtual-subtitle">
      With more than 35000 verified properties LegalAxis
      offers most reliable property legal services
    </p>

  </div>

</div>

<div className="online-section">

  <div className="container">

    <div className="online-grid">

      {/* CARD 1 */}

      <div className="online-card">

        <h3>35K+ Properties</h3>

        <p>
          With more than 35000 verified properties
          LegalAxis offers most reliable property
          legal service.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="online-card">

        <h3>All in One Solution</h3>

        <p>
          Property verification, legal drafting,
          property registration everything under
          one roof.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="online-card">

        <h3>Trusted in 80 Countries</h3>

        <p>
          Indians around the globe in more than
          80 countries trust LegalAxis for property
          related matters.
        </p>

      </div>

    </div>

  </div>

</div>

{/* PROPERTY HELP SECTION */}

<div className="property-help-section">

  <div className="container">

    <div className="property-help-wrapper">

      {/* LEFT CONTENT */}

      <div className="property-help-content">

        <h2>
          Get Expert Property Legal Advice
        </h2>

        <p>
          Our experienced property lawyers help you with
          verification, registration, drafting and complete
          legal assistance before buying your dream property.
        </p>

        <button>
          Talk to Expert
        </button>

      </div>

      {/* RIGHT IMAGE */}

      <div className="property-help-image">

        <img
          src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1974&auto=format&fit=crop"
          alt="Property"
        />

      </div>

    </div>

  </div>

</div>

    </div>
  );
}

export default Property;